import React, { useEffect, useRef } from 'react';
import { SideNav } from '@ab-inbev-maz/compass';
import './Sidebar.css'; // Importamos los estilos personalizados
import { useReportsStore } from '../stores/reportsStore';

const Sidebar: React.FC = () => {
  const [active, setActive] = React.useState(false);
  const [errorCount, setErrorCount] = React.useState(0);
  const sideNavRef = useRef<HTMLDivElement>(null);
  const getErrorCount = useReportsStore((state) => state.getErrorCount);
  
  const toggle = () => {
    setActive(!active);
  };

  useEffect(() => {
    const fetchErrorCount = async () => {
      const count = await getErrorCount();
      setErrorCount(count);
    };

    void fetchErrorCount();

    const intervalId = setInterval(fetchErrorCount, 60000);

    return () => clearInterval(intervalId);
  }, [getErrorCount]);

  useEffect(() => {
    setTimeout(() => {
      if (sideNavRef.current) {
        const errorLink = sideNavRef.current.querySelector('a[href="/errors"]');
        if (errorLink) {
          if (errorCount > 0) {
            errorLink.setAttribute('data-notifications', 'true');
          } else {
            errorLink.removeAttribute('data-notifications');
          }
        }
      }
    }, 100);
  }, [active, errorCount]);

  return (
    <div ref={sideNavRef} className="sidebar-container">
      <SideNav
        className='z-10 custom-sidebar h-full sidebar-container'
        active={active}
        toggle={toggle}
        sections={
          [
            {
              items: [
                {
                  icon: 'layout/app-grid',
                  text: 'Dashboard',
                  to: '/',
                },
                {
                  icon: 'media/image-add',
                  text: 'Listado de templates',
                  to: '/templates/table',
                },
                {
                  icon: 'shopping/beer',
                  text: 'Combos creados',
                  to: '/combos/table',
                },
                {
                  icon: 'shopping/rules',
                  text: 'Listado de reglas',
                  to: '/rules/table',
                },
                {
                  icon: 'shopping/mix-and-match',
                  text: 'Listado de SKU´s',
                  to: '/skus/table',
                },
                // {
                //   icon: 'system/document-signed',
                //   text: 'Listado de legales',
                //   to: '/legals/table',
                // },
                {
                  icon: 'validation/alert-octagon',
                  text: 'Gestión de errores',
                  to: '/errors',
                  notifications: errorCount > 0 ? errorCount : undefined
                },
                // {
                //   icon: 'system/settings',
                //   text: 'Configuración',
                //   to: '/settings',
                // },
              ],
            },
          ]
        }
      />
    </div>
  );
};

export default Sidebar;
